import { render, staticRenderFns } from "./UniformDetailForm.vue?vue&type=template&id=b6595cce&scoped=true"
import script from "./UniformDetailForm.vue?vue&type=script&lang=js"
export * from "./UniformDetailForm.vue?vue&type=script&lang=js"
import style0 from "./UniformDetailForm.vue?vue&type=style&index=0&id=b6595cce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6595cce",
  null
  
)

export default component.exports